export const DOCUMENTS = {
  BUSINESS: 'businesses/{businessId}',
} as const
